import { useShowContext } from 'ra-core';
import { DocumentEmailSender } from '../shared/DocumentEmailSender';

export const PIEmailModal = ({ open, onClose }: { open: boolean, onClose: () => void }) => {
    const { record } = useShowContext();

    return (
        <DocumentEmailSender 
            open={open} 
            onClose={onClose} 
            record={record} 
            resource="proforma_invoices" 
        />
    );
};
